<template>
  <div>
    <ion-item class="ion-margin-bottom" lines="none">
      <ion-label>Tage</ion-label>
      <ion-select
        placeholder="Bitte wählen"
        multiple
        v-model="selectedDays"
        cancel-text="Abbrechen"
      >
        <template v-for="day in days" :key="day">
          <ion-select-option>{{ day }}</ion-select-option>
          <!-- <ion-select-option v-for="time in times" :key="time">
            {{ day + " " + time }}
          </ion-select-option> -->
        </template>
      </ion-select>
    </ion-item>
    <ion-item
      v-for="selectedDay in selectedDays"
      :key="selectedDay"
      lines="none"
    >
      <ion-icon
        style="margin-inline-end: 10px"
        :icon="timeOutline"
        size="small"
        slot="start"
      ></ion-icon>
      <ion-label>{{ selectedDay }}</ion-label>
      <ion-select
        placeholder="Bitte wählen"
        multiple
        v-model="time[selectedDay]"
        cancel-text="Abbrechen"
      >
        <ion-select-option value="Vormittag">Vormittag</ion-select-option>
        <ion-select-option value="Nachmittag">Nachmittag</ion-select-option>
      </ion-select>
    </ion-item>
    <!-- <ion-item lines="none">
            <ion-label>Uhrzeiten</ion-label>
            <ion-datetime
                placeholder="00:00"
                v-model="from"
                displayFormat="HH:mm"
                pickerFormat="HH:mm"
                cancelText="Abbrechen"
                doneText="Fertig"
            ></ion-datetime>
            &nbsp;bis&nbsp;
            <ion-datetime
                placeholder="00:00"
                v-model="to"
                displayFormat="HH:mm"
                pickerFormat="HH:mm"
                cancelText="Abbrechen"
                doneText="Fertig"
            ></ion-datetime>
        </ion-item> -->
    <next-question-button
      :disabled="valueString === '' || valueString.endsWith(', ')"
      @click="emitValues"
    />
  </div>
</template>

<script>
import NextQuestionButton from "./NextQuestionButton";
import {
  IonItem,
  IonLabel,
  // IonDatetime,
  IonSelect,
  IonSelectOption,
  IonIcon,
} from "@ionic/vue";
import { timeOutline } from "ionicons/icons";

export default {
  components: {
    NextQuestionButton,
    IonItem,
    IonLabel,
    // IonDatetime,
    IonSelect,
    IonSelectOption,
    IonIcon,
  },
  props: {
    question: {
      required: true,
      type: Object,
    },
  },
  setup() {
    return { timeOutline };
  },
  data() {
    return {
      days: [
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag",
        "Sonntag",
      ],
      selectedDays: [],
      from: "",
      to: "",
      time: {},
      times: ["vorm.", "nachm."],
    };
  },
  methods: {
    emitValues() {
      this.$emit("done", {
        value: this.valueString,
        id: this.question.id,
      });
    },
  },
  computed: {
    valueString() {
      let value = "";
      for (const [index, day] of this.selectedDays.entries()) {
        if (this.time?.[day]?.length > 0) {
          value += day + " " + this.time[day].join(" und ");
          if (this.selectedDays[index + 1]) {
            value += ", ";
          }
        }
      }
      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
.in-item {
  max-width: 70%;
}
</style>
